import React from 'react';

import {Stack, Box, Card, CardContent, Skeleton, Grid, Divider} from 'views/components';

const SkeletonSectionLoader = () => {
  const steps = [1, 2, 3];

  return (
    <Stack spacing={4}>
      <Stack spacing={1}>
        <Skeleton variant="text" width="40%" height={32} />
        <Skeleton variant="text" width="55%" height={20} />
      </Stack>

      <Stack spacing={1}>
        <Skeleton variant="text" width="30%" height={26} />
        <Card>
          <CardContent>
            <Stack direction={{xs: 'column', md: 'row'}} spacing={3} alignItems={{md: 'center'}}>
              {steps.map((step, idx) => (
                <React.Fragment key={step}>
                  <Stack
                    spacing={1}
                    alignItems="center"
                    sx={{minWidth: {md: 200}, textAlign: 'center'}}
                  >
                    <Skeleton variant="circular" width={52} height={52} />
                    <Skeleton variant="text" width="70%" height={20} />
                    <Skeleton variant="text" width="80%" height={18} />
                    <Skeleton variant="rounded" width={120} height={32} />
                  </Stack>
                  {idx !== steps.length - 1 && (
                    <Box
                      sx={{
                        flex: 1,
                        borderTop: '2px dashed',
                        borderColor: 'grey.300',
                        display: {xs: 'none', md: 'block'},
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </Stack>
          </CardContent>
        </Card>
      </Stack>

      <Divider />

      <Stack spacing={1}>
        <Skeleton variant="text" width="30%" height={26} />
        <Skeleton variant="text" width="50%" height={18} />
        <Grid container spacing={2} pl={0} mt={0}>
          {[0, 1].map((idx) => (
            <Grid key={idx} item xs={12} md={6} lg={4}>
              <Card>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center" sx={{mb: 2}}>
                    <Skeleton variant="circular" width={56} height={56} />
                    <Stack spacing={0.5} sx={{flex: 1}}>
                      <Skeleton variant="text" width="70%" height={20} />
                      <Skeleton variant="text" width="60%" height={18} />
                    </Stack>
                  </Stack>
                  <Skeleton variant="rounded" width="100%" height={38} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Stack>
  );
};

export default SkeletonSectionLoader;
